import type { TOC } from '@ember/component/template-only';
import { array } from '@ember/helper';

import joinClasses from 'webapp/helpers/join-classes';

interface NotificationsEditFormRowInterface {
	Args: {
		label: string;
		className?: string;
	};
	Blocks: {
		default: [];
	};
}

const NotificationsEditFormRowComponent: TOC<NotificationsEditFormRowInterface> = <template>
	<div class={{joinClasses (array "row" @className)}}>
		<label>{{@label}}</label>
		<div class="right">
			{{yield}}
		</div>
	</div>
</template>;

export default NotificationsEditFormRowComponent;
